import React from 'react';
import Image from 'next/image';

const PythonSoftwareImage = () => {
    return (
        <div>
            <div className="container-fluid">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-12 text-center">
                        <Image
                            src="/img/python/svg/vector-from-code-to-cloud.svg"
                            className="img-fluid w-full"
                            alt="Python Development Services"
                            title="Python Development Services"
                            height={187}
                            width={1380}
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PythonSoftwareImage;
